import Request from './request';
import { getSaveableDateWithTime } from "../utils/DateHelper";
import FieldNames from "../defaults/FieldNames.json";
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const MeasurementService = {
  addMeasurementEntry: function (feature, joinID, joinFeature, modifiedBy) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      const entity = feature?.attributes ? feature.attributes : feature;
      const measurementEntry = {
        MeasureAmount: entity[FieldNames.featureFields.measureAmount],
        UnitOfMeasure: entity[FieldNames.featureFields.unitOfMeasure],
        Notes: null,
        JoinID: joinID ?? entity[FieldNames.featureFields.joinID],
        JoinFeature: joinFeature,
        CreatedBy: modifiedBy,
        CreatedOnDate: getSaveableDateWithTime(),
        LastModifiedBy: modifiedBy,
        LastModifiedDate: getSaveableDateWithTime(),
      }
      const newMeasurementEntry = 
      {
          attributes: measurementEntry
      }
      return new Promise((resolve, reject) => {
        new Request().makeRequest({
          url: rootServiceUrl + "/" + config.measurements[config.env].layerId + "/addFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify([newMeasurementEntry])
          }
        }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            }
        );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }

  },
  updateMeasurementEntry: function (feature, joinID, joinFeature, modifiedBy) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      const entity = feature?.attributes ? feature.attributes : feature;
      const measurementEntry = {
        OBJECTID: entity[FieldNames.featureFields.measurementOBJECTID],
        MeasureAmount: entity[FieldNames.featureFields.measureAmount],
        UnitOfMeasure: entity[FieldNames.featureFields.unitOfMeasure],
        LastModifiedBy: modifiedBy,
        LastModifiedDate: getSaveableDateWithTime(),
      }
      const updatedMeasurementEntry = 
      {
          attributes: measurementEntry
      }
      return new Promise((resolve, reject) => {
        new Request().makeRequest({
          url: rootServiceUrl + "/" + config.measurements[config.env].layerId + "/updateFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify([updatedMeasurementEntry])
          }
        }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            }
        );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }

  },
};

export default MeasurementService;